/**
 * GraphQL queries for the Connections Scorecard dashboard.
 * Schema defined in DasFinSuiteBackendCDK lib/graphql/schema.graphql.
 */

export const listConnectionsLeaders = /* GraphQL */ `
  query ListConnectionsLeaders($includeInactive: Boolean, $viewerLogin: String, $isPoweruser: Boolean) {
    listConnectionsLeaders(includeInactive: $includeInactive, viewerLogin: $viewerLogin, isPoweruser: $isPoweruser) {
      leaderId
      leaderLogin
      displayName
      orgLogin
      level
      span
      hasDirectOrgBreakdown
      isActive
    }
  }
`;

export const getConnectionsScorecard = /* GraphQL */ `
  query GetConnectionsScorecard(
    $leaderLogin: String!
    $metricPeriod: String!
    $startDate: String
    $scope: String
    $summaryType: String
    $viewerLogin: String
    $isPoweruser: Boolean
  ) {
    getConnectionsScorecard(
      leaderLogin: $leaderLogin
      metricPeriod: $metricPeriod
      startDate: $startDate
      scope: $scope
      summaryType: $summaryType
      viewerLogin: $viewerLogin
      isPoweruser: $isPoweruser
    ) {
      leaderLogin
      leaderId
      displayName
      metricPeriod
      scope
      summaryType
      groupByDimension
      hasDirectOrgBreakdown
      lastUpdated
      themes {
        theme
        metricId
        displayName
        metricValue
        unadjustedMetricValue
        sampleSize
        populationSize
        uniqueRespondents
        benchmarkMean
        benchmarkMin
        benchmarkMax
        rangeIndicator
        missingValueReason
      }
    }
  }
`;

export const listConnectionsScorecards = /* GraphQL */ `
  query ListConnectionsScorecards(
    $leaderLogin: String
    $metricPeriod: String
    $startDate: String
    $groupByDimension: String
    $scope: String
    $summaryType: String
    $viewerLogin: String
    $isPoweruser: Boolean
  ) {
    listConnectionsScorecards(
      leaderLogin: $leaderLogin
      metricPeriod: $metricPeriod
      startDate: $startDate
      groupByDimension: $groupByDimension
      scope: $scope
      summaryType: $summaryType
      viewerLogin: $viewerLogin
      isPoweruser: $isPoweruser
    ) {
      leaderLogin
      leaderId
      displayName
      metricPeriod
      scope
      summaryType
      groupByDimension
      groupByValue
      hasDirectOrgBreakdown
      lastUpdated
      themes {
        theme
        metricId
        displayName
        metricValue
        sampleSize
        populationSize
        benchmarkMean
        benchmarkMin
        benchmarkMax
        rangeIndicator
        missingValueReason
      }
    }
  }
`;

export const getConnectionsTrends = /* GraphQL */ `
  query GetConnectionsTrends(
    $leaderLogin: String!
    $theme: String!
    $scope: String
    $summaryType: String
    $viewerLogin: String
    $isPoweruser: Boolean
  ) {
    getConnectionsTrends(
      leaderLogin: $leaderLogin
      theme: $theme
      scope: $scope
      summaryType: $summaryType
      viewerLogin: $viewerLogin
      isPoweruser: $isPoweruser
    ) {
      startDate
      metricPeriod
      metricValue
      sampleSize
      benchmarkMean
      benchmarkMin
      benchmarkMax
      rangeIndicator
      missingValueReason
    }
  }
`;

export const listConnectionsFreetextTopics = /* GraphQL */ `
  query ListConnectionsFreetextTopics(
    $leaderLogin: String!
    $metricPeriod: String!
    $startDate: String
    $viewerLogin: String
    $isPoweruser: Boolean
  ) {
    listConnectionsFreetextTopics(
      leaderLogin: $leaderLogin
      metricPeriod: $metricPeriod
      startDate: $startDate
      viewerLogin: $viewerLogin
      isPoweruser: $isPoweruser
    ) {
      topicId
      topicName
      sentiment
      metricValue
      responseCount
      sampleSize
    }
  }
`;

export const listConnectionsQuestionResponses = /* GraphQL */ `
  query ListConnectionsQuestionResponses(
    $leaderLogin: String!
    $metricPeriod: String!
    $startDate: String
    $viewerLogin: String
    $isPoweruser: Boolean
  ) {
    listConnectionsQuestionResponses(
      leaderLogin: $leaderLogin
      metricPeriod: $metricPeriod
      startDate: $startDate
      viewerLogin: $viewerLogin
      isPoweruser: $isPoweruser
    ) {
      questionId
      questionText
      parentQuestionId
      parentQuestionText
      responseOptionId
      responseOptionText
      score
      responseCount
      sampleSize
    }
  }
`;

export const getConnectionsHeadcount = /* GraphQL */ `
  query GetConnectionsHeadcount($leaderLogin: String!, $startDate: String, $endDate: String, $viewerLogin: String, $isPoweruser: Boolean) {
    getConnectionsHeadcount(
      leaderLogin: $leaderLogin
      startDate: $startDate
      endDate: $endDate
      viewerLogin: $viewerLogin
      isPoweruser: $isPoweruser
    ) {
      leaderLogin
      leaderEmployeeId
      displayName
      scenario
      metricName
      metricMonth
      metricValue
    }
  }
`;

export const listConnectionsFreetextResponses = /* GraphQL */ `
  query ListConnectionsFreetextResponses(
    $leaderLogin: String!
    $metricPeriod: String!
    $startDate: String!
    $topic: String
    $sentiment: String
    $viewerLogin: String
    $isPoweruser: Boolean
  ) {
    listConnectionsFreetextResponses(
      leaderLogin: $leaderLogin
      metricPeriod: $metricPeriod
      startDate: $startDate
      topic: $topic
      sentiment: $sentiment
      viewerLogin: $viewerLogin
      isPoweruser: $isPoweruser
    ) {
      responseHash
      questionText
      sentiment
      topic
      writtenResponse
      theme
      dataMonth
    }
  }
`;
